import { __awaiter } from "tslib";
import { callService, loadWebtexte } from "@phoenixreisen/gateway";
import isEmail from "validator/lib/isEmail";
import isAlpha from "validator/lib/isAlpha";
import dt from "date-and-time";
import Model from "./model";
export function getWebtexts() {
    return __awaiter(this, void 0, void 0, function* () {
        const categories = [
            "sb_agb_label",
            "sb_kundenauthentifizierung_see",
            "sb_kundenauthentifizierung_fluss",
            "sb_zahlung",
            "sb_lastschrift_label",
            "sb_lastschrift",
            "sb_rechnung",
            "sb_zusammenfassung",
            "sb_terminauswahl",
            "sb_abschluss",
        ];
        if (Model.webtexts) {
            return Promise.resolve(Model.webtexts);
        }
        return loadWebtexte(categories, "webtexte.schiffsbesichtigung").then((result) => {
            Model.webtexts = result;
            return result;
        });
    });
}
export function getSchedules(type) {
    return __awaiter(this, void 0, void 0, function* () {
        if (Model.schedules[type]) {
            return Promise.resolve(Model.schedules[type]);
        }
        return callService("schiffsbesichtigung.get-besichtigungstermine", {
            typ: type.substring(0, 1),
        }).then((result) => {
            const schedules = result;
            return (Model.schedules[type] = schedules || []);
        });
    });
}
export function getNations() {
    return __awaiter(this, void 0, void 0, function* () {
        if (Model.nations) {
            return Promise.resolve(Model.nations);
        }
        return callService("laender.nationen", {
            type: "get-laender-infos",
        })
            .then((result) => {
            const nations = result;
            return (nations === null || nations === void 0 ? void 0 : nations.all) || [];
        })
            .then((result) => {
            return (Model.nations = result);
        });
    });
}
export function auth(customerid, postcode) {
    return __awaiter(this, void 0, void 0, function* () {
        const result = (yield callService("phxauth.auth-kunde", {
            "kunden-nr": customerid,
            plz: postcode,
        }));
        if (result && result.status === "success" && result.jwt) {
            return result.jwt;
        }
        throw result;
    });
}
export function getCustomer(customerid_1, jwt_1) {
    return __awaiter(this, arguments, void 0, function* (customerid, jwt, force = true) {
        if (!Model.customer || force) {
            const c = yield callService("buchung-repo.get-kundendaten", {
                "kunden-nr": customerid,
                jwt: jwt,
            });
            Model.customer = {
                city: c["kundendaten/ort"] || "",
                email: c["kundendaten/email"] || "",
                postcode: c["kundendaten/plz"] || "",
                gender: c["kundendaten/anrede"] || "",
                phone: c["kundendaten/telefon"] || "",
                prename: c["kundendaten/vorname"] || "",
                address: c["kundendaten/strasse"] || "",
                surname: c["kundendaten/nachname"] || "",
                customerid: c["kundendaten/kunden-nr"] || "",
                country: c["kundendaten/laenderkennung"] || "",
                iban: c["kundendaten/iban"] || null,
            };
        }
        return Model.customer;
    });
}
export function save(model, jwt) {
    return __awaiter(this, void 0, void 0, function* () {
        const { customer, visitors, schedule, payment } = model;
        try {
            const result = yield callService("schiffsbesichtigung.buche-schiffsbesichtigung", {
                "sb-daten": {
                    datum: schedule.datum,
                    schiffskuerzel: schedule.schiff.abkuerzung,
                    kundendaten: {
                        "kundendaten/ort": customer.city,
                        "kundendaten/email": customer.email,
                        "kundendaten/plz": customer.postcode,
                        "kundendaten/anrede": customer.gender,
                        "kundendaten/telefon": customer.phone,
                        "kundendaten/strasse": customer.address,
                        "kundendaten/vorname": customer.prename,
                        "kundendaten/nachname": customer.surname,
                        "kundendaten/kunden-nr": customer.customerid,
                        "kundendaten/laenderkennung": customer.country,
                    },
                    teilnehmer: visitors.map((current) => {
                        const { v: visitor } = current;
                        return schedule.schiff.hochsee
                            ? {
                                anrede: visitor.gender,
                                vorname: visitor.prename,
                                nachname: visitor.surname,
                                geburtsdatum: visitor.birth,
                                passnummer: visitor.passport.id,
                                nationalitaet: visitor.nationality,
                                "pass-verfallsdatum": visitor.passport.until,
                                "pass-ausstellungsort": visitor.passport.place,
                                "pass-ausstellungsdatum": visitor.passport.from,
                            }
                            : {
                                anrede: visitor.gender,
                                vorname: visitor.prename,
                                nachname: visitor.surname,
                            };
                    }),
                    zahlungsdaten: {
                        iban: payment.iban,
                        zahlungsart: payment.method,
                    },
                },
                jwt: jwt,
            });
            return result;
        }
        catch (e) {
            console.error(e);
            throw e;
        }
    });
}
export function getShips(schedules, shipType, port) {
    const shipnames = [];
    schedules.forEach((schedule) => {
        if ((schedule.schiff.hochsee === (shipType === "hochsee") ||
            shipType === "alle") &&
            (!port || schedule.hafen === port)) {
            if (!shipnames.includes(schedule.schiff.name)) {
                shipnames.push(schedule.schiff.name);
            }
        }
    });
    shipnames.sort();
    return shipnames;
}
export function getPorts(schedules, ship) {
    const portnames = [];
    schedules.forEach((schedule) => {
        if (!ship || schedule.schiff.name === ship) {
            if (!portnames.includes(schedule.hafen)) {
                portnames.push(schedule.hafen);
            }
        }
    });
    portnames.sort();
    return portnames;
}
export function filterSchedules(data, schedules) {
    const found = [];
    const query = {
        ship: data.ship || null,
        port: data.port || null,
        to: (data.to && dt.parse(data.to, "DD.MM.YYYY")) || null,
        from: (data.from && dt.parse(data.from, "DD.MM.YYYY")) || null,
    };
    schedules.forEach((schedule) => {
        const date = dt.parse(schedule.datum, "YYYY-MM-DD");
        if ((!query.ship || query.ship === schedule.schiff.name) &&
            (!query.port || query.port === schedule.hafen) &&
            (!query.from || query.from <= date) &&
            (!query.to || query.to >= date)) {
            found.push(schedule);
        }
    });
    return found;
}
export function groupBy(groupBy, schedules) {
    const grouped = {};
    for (const sched of schedules) {
        const key = groupBy === "schiff"
            ? sched.schiff.name
            : groupBy === "hafen"
                ? sched.hafen
                : sched.datum;
        if (grouped[key]) {
            grouped[key].push(sched);
        }
        else {
            grouped[key] = [sched];
        }
    }
    return grouped;
}
export function getBackLink(schedule, page) {
    if (schedule) {
        switch (page) {
            case "customer":
                return schedule.schiff.hochsee ? "/see" : "/fluss";
            case "summary":
                if (schedule["preis-erwachsener"] > 0 ||
                    schedule["reduzierter-preis"] > 0) {
                    return "/zahlung";
                }
                else {
                    return "/besucher";
                }
        }
    }
    return "/";
}
export function isValidCustomer(customer, setError) {
    const { address, city, postcode, country } = customer;
    const { gender, prename, surname } = customer;
    const { email, phone } = customer;
    const errors = {
        city: !city,
        phone: !phone,
        gender: !gender,
        address: !address,
        country: !country,
        postcode: !postcode,
        email: !email || !isEmail(email),
        prename: !prename || !isAlpha(prename, "de-DE", { ignore: " .-" }),
        surname: !surname || !isAlpha(surname, "de-DE", { ignore: " .-" }),
    };
    for (const fieldname of Object.keys(errors)) {
        if (errors[fieldname]) {
            setError(errors);
            return false;
        }
    }
    return true;
}
export function isCustomerFormDisabled() {
    return Model.customerFromDatabase;
}
export function setCustomerFormDisabled(status) {
    Model.customerFromDatabase = status;
}
export function getOrSetJwt(jwt) {
    if (typeof jwt === "string") {
        Model.jwt = jwt;
    }
    return Model.jwt;
}
export function hasErrors(values) {
    for (const key of Object.keys(values)) {
        const prop = values[key];
        if (typeof prop === "object") {
            if (hasErrors(prop)) {
                return true;
            }
        }
        else if (!!prop === true) {
            return true;
        }
    }
    return false;
}
export function isValidVisitorList(isSea, visitors) {
    var _a, _b, _c, _d;
    for (const current of visitors) {
        const { v: visitor } = current;
        current.e = {
            gender: !visitor.gender,
            prename: !visitor.prename,
            surname: !visitor.surname,
            birth: isSea ? !visitor.birth : false,
            nationality: isSea ? !visitor.nationality : false,
            passport: {
                id: isSea ? !((_a = visitor.passport) === null || _a === void 0 ? void 0 : _a.id) : false,
                place: isSea ? !((_b = visitor.passport) === null || _b === void 0 ? void 0 : _b.place) : false,
                until: isSea ? !((_c = visitor.passport) === null || _c === void 0 ? void 0 : _c.until) : false,
                from: isSea ? !((_d = visitor.passport) === null || _d === void 0 ? void 0 : _d.from) : false,
            },
        };
    }
    if (visitors.length === 0) {
        return false;
    }
    for (const item of visitors) {
        if (hasErrors(item.e)) {
            return false;
        }
    }
    return true;
}
export function validatePassNumber(value) {
    const numbers = "0123456789";
    const letters = "CFGHJKLMNPRTVWXYZ";
    const allowed = `${letters}${numbers};`;
    return value.split("").filter((letter) => !allowed.includes(letter));
}
export const isValidGermanPassNo = (id) => {
    const invalidLetters = validatePassNumber(id);
    return !invalidLetters.length && [8, 9].includes(id.length);
};
